import {makeObservable, observable} from "mobx";

import {DocumentRevisionType} from "../../../api/values/document-revision-type";
import {BigIntId} from "../../../utils/big-int-id";
import dayjs, {Dayjs} from "../../../utils/dayjs";

export class DocumentListRevisionItem {
    @observable
    public id: BigIntId = new BigIntId("0");

    @observable
    public revisionName: string = "";

    @observable
    public revisionType: DocumentRevisionType = DocumentRevisionType.NORMAL;

    @observable
    public updatedAt: Dayjs = dayjs();

    @observable
    public userNames: string[] = [];

    public constructor(args?: Partial<DocumentListRevisionItem>) {
        makeObservable(this);
        Object.assign(this, args);
    }
}
